import { render, staticRenderFns } from "./BackgroundButton.vue?vue&type=template&id=2ad5f010&scoped=true"
import script from "./BackgroundButton.vue?vue&type=script&lang=js"
export * from "./BackgroundButton.vue?vue&type=script&lang=js"
import style0 from "./BackgroundButton.vue?vue&type=style&index=0&id=2ad5f010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad5f010",
  null
  
)

export default component.exports